(() => {
  try {
    const KEY = "purchase_origin";

    const getOrigin = () => {
      const url = new URL(window.location.href);
      return (
        sessionStorage.getItem(KEY) ||
        url.searchParams.get("origin") ||
        ""
      );
    };

    const apply = () => {
      const origin = getOrigin();

      document
        .querySelectorAll('input.js-origin-property[name="properties[_origin]"]')
        .forEach((el) => {
          if (!origin) {
            // si no hay origen, no lo enviamos
            el.disabled = true;
            el.value = "";
          } else {
            el.disabled = false;
            el.value = origin;
          }
        });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", apply);
    } else {
      apply();
    }

    document.addEventListener("shopify:section:load", apply);
    document.addEventListener("purchase-origin:changed", apply);
  } catch (e) {
    // no-op
  }
})();
